export default __webpack_public_path__ + "7615be16eed41f806def1ba19d38b46d.png";